import { Sites } from '@uno/common-shared';
import { TestTaxonomyName } from "./taxonomyName";
var PERSON_TYPE = {
  name: TestTaxonomyName.PersonType,
  hierarchical: false,
  site: Sites.TEST
};
export { PERSON_TYPE };